import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import DateDropdown from "@/components/DateDropdown";
import { REM_CONFIG } from "@/utils/fontSize";
import moment from "moment";
const AssetCategoryBudgetComparison = ({ className = "", initDate = moment().format("YYYY-MM") }) => {
    const [selectedDate, setSelectedDate] = useState(initDate);
    const [chartData, setChartData] = useState({
        budget: [7654.72, 2189.12, 23313.83, 189.21],
        purchase: [4465.25, 1707.51, 18417.93, 151.37],
    });
    const chartRef = useRef(null);
    const updateChartData = (time) => {
        setSelectedDate(time);
        setChartData({
            budget: [7654.72, 2189.12, 23313.83, 189.21],
            purchase: [4465.25, 1707.51, 18417.93, 151.37],
        });
    };
    const getChartOption = () => ({
        legend: {
            data: ["预算", "采购"],
            top: 6,
            textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            itemGap: 30,
            itemWidth: 16,
            itemHeight: 8,
            icon: "rect",
            left: "center",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        grid: {
            left: "2%",
            right: "2%",
            bottom: "2%",
            top: 60,
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: ["固定资产", "科研物资", "三剂物资", "低耗用品"],
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                interval: 0,
            }, // 强制显示所有标签 },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
        },
        yAxis: {
            type: "value",
            name: "金额（万元）",
            nameTextStyle: { fontSize: REM_CONFIG.fontSize.small, color: "#FFFFFF" },
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
            splitLine: {
                show: true,
                lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" },
            },
        },
        series: [
            {
                name: "预算",
                type: "bar",
                data: chartData.budget,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#2F96E2" },
                        { offset: 1, color: "#1572C4" },
                    ]),
                    barBorderRadius: [8, 8, 0, 0],
                },
                barWidth: "15%",
            },
            {
                name: "采购",
                type: "bar",
                data: chartData.purchase,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#60FFFF" },
                        { offset: 1, color: "#40C0FF" },
                    ]),
                    barBorderRadius: [8, 8, 0, 0],
                },
                barWidth: "15%",
            },
        ],
    });
    return (_jsxs("div", { className: `
      relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u8D44\u4EA7\u7C7B\u522B\u5BF9\u6BD4\u9884\u7B97", children: _jsx(DateDropdown, { initDate: initDate, onDateChange: (date) => updateChartData(date) }) }), _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { ref: chartRef, option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default AssetCategoryBudgetComparison;
